import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/shared/components/ui/tabs";
import { EmailServiceSettings } from "./EmailServiceSettings";
import { EmailNotificationsSettings } from "./EmailNotificationsSettings";
import { EmailSenderSettings } from "./EmailSenderSettings";

export const EmailSettingsView = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("emailService");

  return (
    <div className="px-2 py-4">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="emailService">{t("settings.sidebar.emailService")}</TabsTrigger>
          <TabsTrigger value="emailNotifications">{t("settings.sidebar.emailNotifications")}</TabsTrigger>
          <TabsTrigger value="emailSender">{t("settings.sidebar.emailSender", { defaultValue: "Sender" })}</TabsTrigger>
        </TabsList>
        <TabsContent value="emailService">
          <EmailServiceSettings />
        </TabsContent>
        <TabsContent value="emailNotifications">
          <EmailNotificationsSettings />
        </TabsContent>
        <TabsContent value="emailSender">
          <EmailSenderSettings />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default EmailSettingsView;
